<template>
  <div>
    <MobileNavButtons
      v-if="$vuetify.display.mobile"
      :Statuses="StatusesWithParentPath"
    />
    <div class="finances-page">
      <div class="button-container">
        <DateFilterGroup
          :fromDate="fromDate"
          :toDate="toDate"
          @update-from-date="updateFromDate"
          @update-to-date="updateToDate"
        />
        <DownloadButton
          v-if="tableMode === 'accounting'"
          @click="isDownloadFileModalOpen = true"
        />
      </div>
      <FinancesTable
        :tableMode="tableMode"
        :financesList="financesList"
        :catalogueList="catalogueList"
      />
      <DownloadFileModal
        v-model="isDownloadFileModalOpen"
        @download="handleDownload"
      />
      <DownloadSuccessModal
        v-model="isDownloadFileSucceedModalOpen"
        :userEmail="getUserEmail"
      />
    </div>
  </div>
</template>

<script>
import FinancesTable from "../helpers/FinancesTable.vue";
import DateFilterGroup from "../helpers/DateFilterGroup.vue";
import DownloadButton from "../helpers/DownloadButton.vue";
import DownloadFileModal from "../UI/modals/DownloadFileModal.vue";
import DownloadSuccessModal from "../UI/modals/DownloadSuccessModal.vue";
import MobileNavButtons from "../helpers/MobileNavButtons.vue";
import { dateToDisplay } from "@/dates";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    MobileNavButtons,
    DateFilterGroup,
    DownloadButton,
    FinancesTable,
    DownloadFileModal,
    DownloadSuccessModal,
  },
  mounted() {
    this.filterFinancesByStatus();
    this.whoComesToTheParty();
    this.setRouteQueryInDateInputs();
    this.financesList = this.sortFinancesBySendDate();
  },
  data() {
    return {
      financesList: [],
      catalogueList: [],
      isDownloadFileModalOpen: false,
      isDownloadFileSucceedModalOpen: false,
      fromDate: "",
      toDate: "",
      address: "",
    };
  },
  watch: {
    toDate() {
      if (this.toDate) {
        let date = moment(this.toDate).format("YYYY-MM-DD");
        this.setRouteQuery({ toDate: date });
      } else {
        this.removeSpecificQuery("toDate");
      }
    },
    fromDate() {
      if (this.fromDate) {
        let date = moment(this.fromDate).format("YYYY-MM-DD");
        this.setRouteQuery({ fromDate: date });
      } else {
        this.removeSpecificQuery("fromDate");
      }
    },
    "$route.params.status"() {
      this.filterFinancesByStatus();
    },
    "$route.query.toDate"() {
      this.whoComesToTheParty();
    },
    "$route.query.fromDate"() {
      this.whoComesToTheParty();
    },
  },
  methods: {
    getFinance() {
      this.$store.dispatch("Finances/getFinances");
    },
    sortFinancesBySendDate() {
      return this.financesList.sort(function (a, b) {
        return new Date(b.senddate) - new Date(a.senddate);
      });
    },
    async handleDownload({ fromDate, toDate }) {
       await this.$store.dispatch("Finances/getFinancePdf");
      // Your download logic here
      console.log(fromDate, toDate);
      this.isDownloadFileSucceedModalOpen = true;
    },
    setRouteQueryInDateInputs() {
      if (this.$route.query.fromDate) {
        this.fromDate = moment(this.$route.query.fromDate).toDate();
      }
      if (this.$route.query.toDate) {
        this.toDate = moment(this.$route.query.toDate).toDate();
      }
    },
    updateFromDate(date) {
      this.fromDate = date;
    },
    updateToDate(date) {
      this.toDate = date;
    },
    formattedDate(date, text) {
      if (!date) return text;
      return dateToDisplay(date);
    },
    whoComesToTheParty() {
      if (this.tableMode === "accounting") {
        if (this.Finances.length) {
          this.financesList = this.Finances.filter((finance) => {
            //if status exists in params, check if current finance come to the party
            if (this.$route.params.status) {
              if (finance.status != this.$route.params.status) {
                return false; //not come to the party
              }
            }
            if (this.$route.query.address) {
              //if address exists in query, check if current order come to the party
              if (!finance.Site) {
                //If there is no site at all
                return false;
              }
              if (finance.Site.description != this.$route.query.address) {
                return false; //not come to the party
              }
            }
            if (this.$route.query.fromDate) {
              //if date exists in query, check if current finance come to the party
              if (
                finance.invoiceDate.split("T")[0] < this.$route.query.fromDate
              ) {
                return false; //not come to the party
              }
            }
            if (this.$route.query.toDate) {
              //if date exists in query, check if current finance come to the party
              if (
                this.$route.query.toDate < finance.invoiceDate.split("T")[0]
              ) {
                return false; //not come to the party
              }
            }
            if (this.$route.query.SKU) {
              //if SKU exists in query, check if current order come to the party
              let partNotExists = finance.OrderLines.every(
                (line) =>
                  !String(line.part).includes(String(this.$route.query.SKU))
              );
              if (partNotExists) {
                return false; //not come to the party
              }
            }
            return true; // All tets passed successfully and the order come to the party!
          });
        }
      } else if (this.tableMode === "catalogue") {
        if (this.Catalogues.length) {
          this.catalogueList = this.Catalogues.filter((catalogue) => {
            if (this.$route.query.address) {
              //if address exists in query, check if current order come to the party
              if (!catalogue.Site) {
                //If there is no site at all
                return false;
              }
              if (catalogue.Site.description != this.$route.query.address) {
                return false; //not come to the party
              }
            }
            if (this.$route.query.fromDate) {
              //if date exists in query, check if current catalogue come to the party
              if (
                catalogue.balanceDate.split("T")[0] < this.$route.query.fromDate
              ) {
                return false; //not come to the party
              }
            }
            if (this.$route.query.toDate) {
              //if date exists in query, check if current catalogue come to the party
              if (
                this.$route.query.toDate < catalogue.balanceDate.split("T")[0]
              ) {
                return false; //not come to the party
              }
            }
            if (this.$route.query.SKU) {
              //if SKU exists in query, check if current order come to the party
              let partNotExists = catalogue.OrderLines.every(
                (line) =>
                  !String(line.part).includes(String(this.$route.query.SKU))
              );
              if (partNotExists) {
                return false; //not come to the party
              }
            }
            return true; // All tets passed successfully and the order come to the party!
          });
        }
      }
    },
    async downloadOrderFile(ordName) {
      try {
        await this.$store.dispatch(
          "Orders/printOrder",
          ordName
        );
      } catch (error) {
        console.log("error printOrder from Orders.vue:");
        console.log(error);
      }
    },
    removeSpecificQuery(key) {
      let query = {
        ...this.$route.query,
      };
      delete query[key];

      this.$router.push({
        path: this.$route.path,
        query: query,
      });
    },
    async setRouteQuery(query) {
      query = {
        ...this.$route.query,
        ...query,
      };
      await this.$router.push({ path: this.$route.path, query: query });
      console.log({ ...this.$route.query, ...this.$route.params });
    },
    filterFinancesByStatus() {
      let status = this.$route.params.status;
      if (status) {
        this.catalogueList = this.Catalogues;
      } else {
        this.financesList = this.Finances;
      }
    },
  },
  computed: {
    StatusesWithParentPath() {
      var updatedStatuses = [...this.Statuses];
      updatedStatuses.unshift({
        id: null,
        count: this.getFinancesCount,
        name: "גיול חובות",
        path: "/finances",
      });
      return updatedStatuses;
    },
    tableMode() {
      return this.$route.params.status ? "catalogue" : "accounting";
    },
    ...mapGetters({
      Finances: "Finances/getFinances",
      getUserEmail: "AuthModule/getUserEmail",
      getFinancesCount: "Finances/getFinancesCount",
      Catalogues: "Finances/getCatalogue",
      Statuses: "Finances/getFinancesStatuses",
    }),
  },
};
</script>

<style scoped lang="scss">
//style for page with scope
@media only screen and (max-width: 601px) {
  .button-container {
    gap: 10px;
    margin-bottom: 20px !important;
    flex-direction: column !important;
  }

  .finances-page {
    padding: 10px !important;
    margin-top: 10px !important;
    max-width: calc(100vw - 40px);
  }
  .mobile-nav-buttons {
    margin-right: 15px;
  }
  .date-filters {
    gap: 20px !important;
  }
}
.modal-content {
  font-size: $mediumTextSize;
  color: $modalContentColor;
  font-weight: 400;
  line-height: 21.33px;
  text-align: center;
  margin-top: -20px;

  .email {
    color: #36b079;
  }
}
.finances-page {
  border: 1px solid #ececec;
  border-radius: 20px;
  margin-top: 50px;
  margin-right: 20px;
  padding-top: 50px;
  padding-bottom: 50px;
  padding-right: 40px;
  padding-left: 40px;
}

.date-filters {
  display: flex;
  gap: 40px;
}
.button-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 40px;
}
</style>
